import { useRef, useState } from 'react';
import { Loading } from 'carbon-components-react';
import { updateStudy } from '../../../api/studyListApi';
import { toaster } from '../../../helpers/toaster';
import './StudyPageImage.scss';

const ACCEPTED_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];

const StudyPageImage = ({ studyId, currentImage, onUpdate }) => {
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef(null);

  const uploadFile = async (file) => {
    if (!file) return;
    if (!ACCEPTED_TYPES.includes(file.type)) {
      toaster('Only .png, .jpg, and .jpeg files are accepted', 'error');
      return;
    }
    setUploading(true);
    const formData = new FormData();
    formData.append('logo', file, file.name);
    const res = await updateStudy(studyId, formData);
    if (res?.data) {
      onUpdate(res.data);
      toaster('Study page image uploaded', 'success');
    }
    setUploading(false);
  };

  const handleRemove = async () => {
    setUploading(true);
    const formData = new FormData();
    formData.append('logo_remove', 'remove');
    const res = await updateStudy(studyId, formData);
    if (res?.data) {
      onUpdate(res.data);
      toaster('Study page image removed', 'success');
    }
    setUploading(false);
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    uploadFile(file);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const onDragLeave = () => {
    setDragOver(false);
  };

  const onFileSelect = (e) => {
    uploadFile(e.target.files[0]);
    e.target.value = '';
  };

  if (uploading) return <Loading withOverlay={false} small />;

  return (
    <div className="study-page-image">
      {currentImage ? (
        <div className="study-page-image__preview">
          <img src={currentImage} alt="Study page" className="study-page-image__img" />
          <button className="study-page-image__remove-btn" onClick={handleRemove}>
            <i className="fal fa-trash-alt" /> Remove
          </button>
        </div>
      ) : (
        <div
          className={`study-page-image__dropzone${dragOver ? ' study-page-image__dropzone--active' : ''}`}
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onClick={() => inputRef.current?.click()}
        >
          <i className="fal fa-cloud-upload study-page-image__dropzone-icon" />
          <span className="study-page-image__dropzone-text">
            Drag and drop an image here, or <span className="study-page-image__dropzone-link">browse</span>
          </span>
          <span className="study-page-image__dropzone-hint">PNG, JPG up to 10MB</span>
          <input
            ref={inputRef}
            type="file"
            accept=".png,.jpg,.jpeg"
            onChange={onFileSelect}
            className="study-page-image__dropzone-input"
          />
        </div>
      )}
    </div>
  );
};

export default StudyPageImage;
